export const BILLING_ADDRESS_TITLE = 'Billing address';
export const REGION_RESTRICTION_MESSAGE = 'Your region is currently subject to regulatory restrictions preventing us from processing purchases in your region.';
export const STATE_PROVINCE_LABEL = 'State / Province';

export const ERRORS = {
    STATE_REQUIRED: 'State of Residence is required',
    PROVINCE_REQUIRED: 'Province is required',
} as const;

export const COUNTRY_CODES = {
    US: 'US',
    CA: 'CA',
    RU: 'RU',
} as const;

export const DEFAULT_COUNTRY_NAME = 'United States';

export const ADDRESS_FIELDS = {
    LINE1: 'line1',
    LINE2: 'line2',
    CITY: 'city',
    POSTCODE: 'postcode',
    ZIP: 'zip',
    STATE: 'state',
    REGION: 'region',
    PROVINCE: 'province',
} as const;
